import type {AxiosError} from 'axios';
import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {login, type LoginErrorResponse, type LoginRequest, type LoginResponse} from '../../http';

export function useLogin(
	options?: UseMutationOptions<LoginResponse, AxiosError<LoginErrorResponse>, LoginRequest>,
): UseMutationResult<LoginResponse, AxiosError<LoginErrorResponse>, LoginRequest> {
	return useMutation<LoginResponse, AxiosError<LoginErrorResponse>, LoginRequest>(
		(request) => login(request).then(({data}) => data),
		options,
	);
}
